// https://git.autodesk.com/BIM360/alloy-react/blob/master/packages/Avatar/Avatar.tsx#L118
const DEFAULT_AVATAR_SUFFIX = /user_X\d{2,3}.png$/i

export default {
	DEFAULT_AVATAR_SUFFIX,
}
